export default {
  edit: "rank:edit",
  create: "rank:create",
  delete: "rank:delete",
  view: "rank:view",
};
